import React, { Component } from 'react'
import kindredlogo from '../../assets/kp png logo.svg';
import '../../App.css';
import '../styles/MainScreen.css';

import SpeakerLeft from '../../assets/Speaker Left.svg';
import SpeakerRight from '../../assets/Speaker Right.svg';
import ArrowLeft from '../../assets/Arrow Left.svg';
import ArrowRight from '../../assets/Arrow Right.svg';
import ArrowDown from '../../assets/Arrow Down 2.svg';

export default class MainScreen extends Component {

    render() {
        // PC VIEW
        return (
            <div className="vertical-flex-container">

                <div className="speakers">
                    <img src={SpeakerLeft} className="left" />
                    <img src={SpeakerRight} className="right" />
                </div>

                <div className="horizontal-flex-container" >
                    <div className="button-container">
                        <div className="button-left" onClick={this.props.leftAction}>
                            Services
                        <img src={ArrowLeft} className="leftArrow" />
                        </div>
                    </div>

                    <div className="main-content-container">
                        <div className="outer-homepage-container">
                            <div className="homepage-container">
                                <img src={kindredlogo} className="logo" />
                                <div className="companyname-container">
                                    {this.props.companyName}
                                </div>
                                <div className="slogan-container">
                                    {this.props.sloganText}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="button-container">
                        <div className="button-right" onClick={this.props.rightAction}>
                            Portfolio
                        <img src={ArrowRight} className="rightArrow" />
                        </div>
                    </div>
                </div>

                <div className="bottom-button-container">
                    <div className="button" onClick={this.props.downAction}>
                        Meet the Team
                    <img src={ArrowDown} className="downArrow" />
                    </div>
                </div>
            </div>
        )
    }
}
